import styled from 'styled-components'

const NestedGroup = styled.div`
  position: relative;
`

export default NestedGroup
